export const PIN_SCHEDULE = [
  {
    from: "2026-03-20",
    to: "2026-03-25",
    pins: [
      "123456", // 1st winner
      "234567", // 2nd winner
      "345678", // 3rd winner
    ],
  },
  {
    from: "2026-03-26",
    to: "2026-03-29",
    pins: [
    "474343",
    "280928",
    "761431",
    "499508",
    "208642",
    "633310",
    "882134",
    "159712",
    "219508",
    "780969",
    "381447",
    "848963",
    "451105",
    "326868",
    "254335",
    "242863",
    "609457",
    "177704",
    "957580",
    "233287",
    "960289",
    "540625",
    "424036",
    "563028",
    "811461",
    "948329",
    "613280",
    "681880",
    "525366",
    "306290",
    "309620",
    "122161",
    "706304",
    "574105",
    "917713",
    "708120",
    "910712",
    "105072",
    "906341",
    "255999",
    "945050",
    "314365",
    "806064",
    "465059",
    "165260",
    "590759",
    "854156",
    "407986",
    "349335",
    "629226",
    "587750",
    "138442",
    "258522",
    "454176",
    "685054",
    "851047",
    "667810",
    "937024",
    "139640",
    "796276",
    "885687",
    "156707",
    "506153",
    "481228",
    "663827",
    "683385",
    "595079",
    "736637",
    "451406",
    "339065",
    "450567",
    "437308",
    "270338",
    "317383",
    "250696",
    "148779",
    "194666",
    "387241",
    "336413",
    "510164",
    "689346",
    "204078",
    "385298",
    "246201",
    "607535",
    "148092",
    "235590",
    "284244",
    "153567",
    "366700",
    "188753",
    "614622",
    "404919",
    "653924",
    "507042",
    "863994",
    "671473",
    "583706",
    "537110",
    "492534",
    "940226",
    "442905",
    "753314",
    "488388",
    "198926",
    "112805",
    "666233",
    "603636",
    "558662",
    "660112",
    "304149",
    "424819",
    "575147",
    "368164",
    "950314",
    "732789",
    "852278",
    "524970",
    "959776",
    "674455",
    "243329",
    "385426",
    "920106",
    "607398",
    "267352",
    "306813",
    "161669",
    "134940",
    "893184",
    "717952",
    "236360",
    "299713",
    "661431",
    "816945",
    "536418",
    "785264",
    "665981",
    "898563",
    "714994",
    "794621",
    "160607",
    "637320",
    "827047",
    "660226",
    "868404",
    "799505",
    "817876",
    "199808",
    "618326",
    "865315",
    "757327",
    "466900",
    "167318",
    "959977",
    "227002",
    "778353",
    "916578",
    "645359",
    "113710",
    "209994",
    "695406",
    "463312",
    "488436",
    "848360",
    "559773",
    "285392",
    "476666",
    "515103",
    "572500",
    "180657",
    "599303",
    "857072",
    "879492",
    "431178",
    "532943",
    "156345",
    "381753",
    "132998",
    "918141",
    "730659",
    "319869",
    "269462",
    "238237",
    "705650",
    "621254",
    "316775",
    "430582",
    "784533",
    "427501",
    "382773",
    "180049",
    "438907",
    "764586",
    "452570",
    "770450",
    "420650",
    "133735",
    "754633",
    "913330",
    "415478",
    "970326",
    "382683",
    "123028",
    "559535",
    "203491",
    "923284",
    "909048",
    "848466",
    "467801",
    "951930",
    "356212",
    "453603",
    "994430",
    "508691",
    "257651",
    "481036",
    "863953",
    "119917",
    "575769",
    "998357",
    "455492",
    "739754",
    "226373",
    "766438",
    "343042",
    "511699",
    "206984",
    "768107",
    "802207",
    "961818",
    "254358",
    "835564",
    "288609",
    "895714",
    "616874",
    "315620",
    "888940",
    "465850",
    "227187",
    "482753",
    "251354",
    "284561",
    "735887",
    "124706",
    "137862",
    "407383",
    "875859",
    "457560",
    "722522",
    "308700",
    "567718",
    "885451",
    "115248",
    "760415",
    "680202",
    "549452",
    "893301",
    "872729",
    "639444",
    "164222",
    "317988",
    "354979",
    "514035",
    "143993",
    "643706",
    "638136",
    "509745",
    "269392",
    "381197",
    "971124",
    "388401",
    "896613",
    "543225",
    "239301",
    "691578",
    "254493",
    "270359",
    "204529",
    "218261",
    "693131",
    "617329",
    "580377",
    "195817",
    "869759",
    "912168",
    "244107",
    "724669",
    "773679",
    "205700",
    "411694",
    "923050",
    "197760",
    "404647",
    "952177",
    "305778",
    "199129",
    "225180",
    "957494",
    "974569",
    "742724",
    "891738",
    "286216",
    "486656",
    "764246",
    "251024",
    "488617",
    "577648",
    "537678",
    "592207",
    "253095",
    "678165",
    "115185",
    "645368",
    "183546",
    "380014",
    "783631",
    "633495",
    "227374",
    "373127",
    "494921",
    "200342",
    "123232",
    "319544",
    "403689",
    "729193",
    "914657",
    "463932",
    "599515",
    "510003",
    "379164",
    "566288",
    "628675",
    "559708",
    "238243",
    "920198",
    "136174",
    "403697",
    "944971",
    "289492",
    "272166",
    "484682",
    "211402",
    "981596",
    "230208",
    "403557",
    "306059",
    "860072",
    "364667",
    "775206",
    "345359",
    "800733",
    "765204",
    "497586",
    "997508",
    "547375",
    "745237",
    "746334",
    "281249",
    "824096",
    "983852",
    "839928",
    "347398",
    "344872",
    "822127",
    "420341",
    "921294",
    "654555",
    "489558",
    "271169",
    "326427",
    "549390",
    "216263",
    "854260",
    "783052",
    "459528",
    "366506",
    "822504",
    "770615",
    "887733",
    "314171",
    "876503",
    "260797",
    "268975",
    "623036",
    "616690",
    "810167",
    "354603",
    "846569",
    "726912",
    "331347",
    "424964",
    "821888",
    "100814",
    "153373",
    "373555",
    "616132",
    "484004",
    "547238",
    "230574",
    "471681",
    "800930",
    "484804",
    "342873",
    "706589",
    "129000",
    "749225",
    "322971",
    "703779",
    "545239",
    "236230",
    "907600",
    "834205",
    "242049",
    "721954",
    "207090",
    "710741",
    "885559",
    "720806",
    "418198",
    "461070",
    "885061",
    "205162",
    "380203",
    "181386",
    "992716",
    "242269",
    "987136",
    "196449",
    "893778",
    "228670",
    "258578",
    "845881",
    "978972",
    "554070",
    "758985",
    "920411",
    "827258",
    "878891",
    "544603",
    "864608",
    "728159",
    "809564",
    "610231",
    "722122",
    "751420",
    "705192",
    "273105",
    "282755",
    "598253",
    "414924",
    "119791",
    "810459",
    "805380",
    "149271",
    "465854",
    "253223",
    "194957",
    "827552",
    "793729",
    "515769",
    "647880",
    "512016",
    "190513",
    "996099",
    "800947",
    "865257",
    "717324",
    "686257",
    "760172",
    "953544",
    "795124",
    "900614",
    "889514",
    "892949",
    "763656",
    "851276",
    "711599",
    "749906",
    "197565",
    "878542",
    "476729",
    "541448",
    "216474",
    "889166",
    "875162",
    "227684",
    "962722",
    "239842",
    "591324",
    "512105",
    "322930",
    "417438",
    "952656",
    "553793",
    "328663",
    "421144",
    "887249",
    "213713",
    "531077",
    "372287",
    "992957",
    "575871",
    "866590",
    "249296",
    "718222",
    "842727",
    "959858",
    "260487",
    "688547",
    "733069",
    "153514",
    "638277",
    "398487",
    "253296",
    "637872",
    "924980",
    "271240",
    "536949",
    "501803",
    "645392",
    "561026",
    "137189",
    "643140",
    "740261",
    "107589",
    "154839",
    "740406",
    "225286",
    "569738",
    "249550",
    "563378",
    "848043",
    "195586",
    "759769",
    "236651",
    "531116",
    "821376",
    "375077",
    "105697",
    "476744",
    "863544",
    "528624",
    "622015",
    "241918",
    "881783",
    "842899",
    "828141",
    "834803",
    "942745",
    "465384",
    "355058",
    "326335",
    "212077",
    "953225",
    "706550",
    "631038",
    "636709",
    "390828",
    "947144",
    "710767",
    "837782",
    "312296",
    "248778",
    "455704",
    "385823",
    "814259",
    "456237",
    "378233",
    "288205",
    "139596",
    "378711",
    "210681",
    "709740",
    "338903",
    "454482",
    "382219",
    "779428",
    "291815",
    "216370",
    "607897",
    "626662",
    "172160",
    "145484",
    "842636",
    "328823",
    "366111",
    "354855",
    "608675",
    "117981",
    "992003",
    "624567",
    "482359",
    "985057",
    "618486",
    "713908",
    "650911",
    "457688",
    "417099",
    "812367",
    "837932",
    "740303",
    "391402",
    "408172",
    "555857",
    "355794",
    "547196",
    "593432",
    "787942",
    "406437",
    "242137",
    "246820",
    "513376",
    "623156",
    "505412",
    "852875",
    "280780",
    "324724",
    "584574",
    "373200",
    "357308",
    "833090",
    "900224",
    "294670",
    "251612",
    "361138",
    "913648",
    "962497",
    "461287",
    "802305",
    "251596",
    "721823",
    "704107",
    "699849",
    "931062",
    "511838",
    "486460",
    "254836",
    "577571",
    "593202",
    "267024",
    "494757",
    "589300",
    "428601",
    "525495",
    "811427",
    "421845",
    "739995",
    "161666",
    "159467",
    "606167",
    "810366",
    "625192",
    "803076",
    "987390",
    "976043",
    "109182",
    "153259",
    "399939",
    "597936",
    "661822",
    "856992",
    "312526",
    "166528",
    "306831",
    "377300",
    "543811",
    "628822",
    "762482",
    "118310",
    "198055",
    "730942",
    "288390",
    "679051",
    "553378",
    "743370",
    "379918",
    "379448",
    "926940",
    "357581",
    "148787",
    "726877",
    "391112",
    "235687",
    "842951",
    "798905",
    "712918",
    "923937",
    "895931",
    "833007",
    "816828",
    "721901",
    "888896",
    "141095",
    "328109",
    "280629",
    "120548",
    "930260",
    "687402",
    "327541",
    "554243",
    "411548",
    "117381",
    "989350",
    "122946",
    "134326",
    "944591",
    "450741",
    "109743",
    "956859",
    "798872",
    "596610",
    "532027",
    "265805",
    "152460",
    "524600",
    "208231",
    "301217",
    "334258",
    "651775",
    "685802",
    "235054",
    "943543",
    "143985",
    "671491",
    "655092",
    "957394",
    "801431",
    "361759",
    "628315",
    "147988",
    "619944",
    "299967",
    "414318",
    "922396",
    "201617",
    "756536",
    "170349",
    "775441",
    "997321",
    "465613",
    "349245",
    "134259",
    "378542",
    "843860",
    "141997",
    "490912",
    "173605",
    "295044",
    "685636",
    "364453",
    "268682",
    "338140",
    "467347",
    "545677",
    "787421",
    "797047",
    "950097",
    "163111",
    "159748",
    "596294",
    "650098",
    "711151",
    "726903",
    "879855",
    "791672",
    "543109",
    "462103",
    "893225",
    "162632",
    "773326",
    "260410",
    "830169",
    "670807",
    "867815",
    "877143",
    "133581",
    "565682",
    "759089",
    "978616",
    "400443",
    "818335",
    "132014",
    "982424",
    "120618",
    "176895",
    "485940",
    "831873",
    "699413",
    "532848",
    "567164",
    "560134",
    "430760",
    "867878",
    "426831",
    "225096",
    "896924",
    "332439",
    "202897",
    "170565",
    "219740",
    "724861",
    "267224",
    "776319",
    "872205",
    "482660",
    "510853",
    "308269",
    "430870",
    "763625",
    "498314",
    "599559",
    "137805",
    "385294",
    "773434",
    "971563",
    "940959",
    "392235",
    "973315",
    "812900",
    "239139",
    "277998",
    "754866",
    "815990",
    "109408",
    "451430",
    "363970",
    "881155",
    "720522",
    "712485",
    "216089",
    "314164",
    "669081",
    "897208",
    "219819",
    "828575",
    "209993",
    "544943",
    "488812",
    "705697",
    "477484",
    "763662",
    "501106",
    "265640",
    "583182",
    "512640",
    "567199",
    "402752",
    "561272",
    "548604",
    "886189",
    "137565",
    "522604",
    "740946",
    "633198",
    "950873",
    "830255",
    "764673",
    "833893",
    "679483",
    "776907",
    "451255",
    "628553",
    "144514",
    "278946",
    "971691",
    "764522",
    "194756",
    "699624",
    "559361",
    "709382",
    "267678",
    "650963",
    "660885",
    "849289",
    "401183",
    "748386",
    "336802",
    "686951",
    "174614",
    "588222",
    "603073",
    "936936",
    "614589",
    "372562",
    "170523",
    "901633",
    "897119",
    "564843",
    "170180",
    "833929",
    "478074",
    "635647",
    "690044",
    "233633",
    "762789",
    "769296",
    "517211",
    "270639",
    "600095",
    "181446",
    "429818",
    "383075",
    "428076",
    "767053",
    "286177",
    "564934",
    "595303",
    "458641",
    "689912",
    "238947",
    "153814",
    "262280",
    "722391",
    "218940",
    "478817",
    "778792",
    "941810",
    "756852",
    "599003",
    "952504",
    "132672",
    "984550",
    "320467",
    "412237",
    "239430",
    "461936",
    "355763",
    "946445",
    "400422",
    "791614",
    "576735",
    "312100",
    "479155",
    "778508",
    "535970",
    "302620",
    "216773",
    "877210",
    "194561",
    "304644",
    "785382",
    "806276",
    "420534",
    "438172",
    "800643",
    "555846",
    "697498",
    "695648",
    "651011",
    "247945",
    "468814",
    "390404",
    "183336",
    "418627",
    "248875",
    "309663",
    "739138",
    "857778",
    "630224",
    "499256",
    "300268",
    "858803",
    "665200",
    "702607",
    "916246",
    "424061",
    "661466",
    "506561",
    "422275",
    "238823",
    "372354",
    "426635",
    "305192",
    "473727",
    "540970",
    "427008",
    "752948",
    "468129",
    "979842",
    "945320",
    "704488",
    "486395",
    "353936",
    "920011",
    "547485",
    "498669",
    "416027",
    "572244",
    "315313",
    "335434",
    "503461",
    "732663",
    "332210",
    "521447",
    "689332",
    "435340",
    "538308",
    "319240",
    "449852",
    "137470",
    ],
  },
  {
    from: '2026-04-08', 
    to: '2026-04-10',
    pins: [
    '111111',
    '222222',
    '333333',
    '444444',
    '555555',
    '666666',
    '777777',
    '888888',
    '999999',
    '000000',

    '111111',
    '222222',
    '333333',
    '444444',
    '555555',
    '666666',
    '777777',
    '888888',
    '999999',
    '000000',

    '111111',
    '222222',
    '333333',
    '444444',
    '555555',
    '666666',
    '777777',
    '888888',
    '999999',
    '000000',

    '111111',
    '222222',
    '333333',
    '444444',
    '555555',
    '666666',
    '777777',
    '888888',
    '999999',

    '000000',
    '111111',
    '222222',
    '333333',
    '444444',
    '555555',
    '666666',
    '777777',
    '888888',
    '999999',
    '000000'
    ],
  },

 // '100488'
//   '042026'
//   '111946'
//   '011966'
//   '000001'
//   '011988'
//   '041826'
//   '884010'
//   '081949'
//   '000022'

  {
    from: "2026-04-11",
    to: "2026-04-11",
    pins: [
    '100488',
    '042026',
    '111946',
    '011966',
    '000001',
    '011988',
    '041826',
    '884010',
    '081949',
    '000022',

    '100488',
    '042026',
    '111946',
    '011966',
    '000001',
    '011988',
    '041826',
    '884010',
    '081949',
    '000022',

    '100488',
    '042026',
    '111946',
    '011966',
    '000001',
    '011988',
    '041826',
    '884010',
    '081949',
    '000022',

    '100488',
    '042026',
    '111946',
    '011966',
    '000001',
    '011988',
    '041826',
    '884010',
    '081949',
    '000022',

    '100488',
    '042026',
    '111946',
    '011966',
    '000001',
    '011988',
    '041826',
    '884010',
    '081949',
    '000022',

    '100488',
    '042026',
    '111946',
    '011966',
    '000001',
    '011988',
    '041826',
    '884010',
    '081949',
    '000022',

    '100488',
    '042026',
    '111946',
    '011966',
    '000001',
    '011988',
    '041826',
    '884010',
    '081949',
    '000022',

    '100488',
    '042026',
    '111946',
    '011966',
    '000001',
    '011988',
    '041826',
    '884010',
    '081949',
    '000022',

    '100488',
    '042026',
    '111946',
    '011966',
    '000001',
    '011988',
    '041826',
    '884010',
    '081949',
    '000022',

    '100488',
    '042026',
    '111946',
    '011966',
    '000001',
    '011988',
    '041826',
    '884010',
    '081949',
    '000022',
    ],
  },
  {
    from: "2026-04-23",
    to: "2026-04-26",
    pins: ["777777", "888888", "999999"],
  },
  {
    from: "2026-04-30",
    to: "2026-05-03",
    pins: ["101010", "202020", "303030"],
  },
  {
    from: "2026-05-08",
    to: "2026-05-10",
    pins: ["121212", "131313", "141414"],
  },
  {
    from: "2026-05-15",
    to: "2026-05-17",
    pins: ["151515", "161616", "171717"],
  },
  {
    from: "2026-05-22",
    to: "2026-05-24",
    pins: ["181818", "191919", "202020"],
  },
  {
    from: "2026-05-29",
    to: "2026-05-31",
    pins: ["212121", "232323", "242424"],
  },
  {
    from: "2026-06-05",
    to: "2026-06-07",
    pins: ["252525", "262626", "272727"],
  },
  {
    from: "2026-06-12",
    to: "2026-06-14",
    pins: ["282828", "292929", "303030"],
  },
  {
    from: "2026-06-15",
    to: "2026-06-19",
    pins: ["313131", "323232", "333333"],
  },
];
